import { z } from 'zod'

// Bounds mirror the runtime ceilings in aria-web src/common/constants.py; PublicApiAccess.test.tsx checks the served spec.
export const POLICY_FIELDS = {
  bucket_capacity: { label: 'Burst size', hint: 'Requests an organization can send at once.', min: 1, max: 250 },
  refill_tokens: { label: 'Refill amount', hint: 'Requests added back each interval.', min: 1, max: 50 },
  refill_period_seconds: {
    label: 'Refill interval (seconds)',
    hint: 'How often the refill amount is added.',
    min: 1,
    max: 60,
  },
} as const

export const POLICY_FIELD_NAMES = Object.keys(POLICY_FIELDS) as (keyof typeof POLICY_FIELDS)[]

const bounded = ({ label, min, max }: { label: string; min: number; max: number }) =>
  z.coerce
    .number<number>({ error: `${label} must be a number` })
    .int(`${label} must be a whole number`)
    .min(min, `${label} must be at least ${min}`)
    .max(max, `${label} must be at most ${max}`)

export const policySchema = z.object({
  enabled: z.boolean(),
  bucket_capacity: bounded(POLICY_FIELDS.bucket_capacity),
  refill_tokens: bounded(POLICY_FIELDS.refill_tokens),
  refill_period_seconds: bounded(POLICY_FIELDS.refill_period_seconds),
})

export type PolicyFormValues = z.infer<typeof policySchema>

// The initial customer policy from runbooks/public-api.md: five requests/sec with no burst.
export const DEFAULT_POLICY: PolicyFormValues = {
  enabled: false,
  bucket_capacity: 5,
  refill_tokens: 5,
  refill_period_seconds: 1,
}
